export default __webpack_public_path__ + "static/bBFVHTtK-3e1511e93d617b40a484de26d07751ba.svg";